import React, { useState } from "react";
import {
  ADDRESSICON_IMG,
  APP_IMG,
  BACKTOTOP_IMG,
  CALLICON_IMG,
  EMAILICON_IMG,
  FACEBOOKICON_IMG,
  JANA_LOGO_P_1,
  JANA_LOGO_P_2,
  JANA_LOGO_P_3,
  JANA_LOGO_P_4,
  JANA_LOGO_P_5,
  GOOGLE_IMG,
  LEFTARROW_IMG,
  LOGOICON_IMG,
  NUMBERICON_IMG,
  TWITTERICON_IMG,
  YOUTUBEICON_IMG,
  APP_NO_IMG,
  SENDBTN_ICON,
  PMBIFOOTERBTN,
  PMBIFOOTERCROSSBTN,
  TWITTER1_IMG,
  JANA_LOGO_P_7,
} from "../../utils/app-image-contant";
import { ROUTES } from "../../hooks/routes/url-constant";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { getApplicationByApplicationId } from "../../hooks/services/api-services";
import { toastEmitter } from "../../utils/utilities";
import { API_RESPONSE } from "../../utils/app-constants";
import ChatBot from "./chatBot";
import { useSelector } from "react-redux";
import QRCode from "react-qr-code";

const Footer = () => {
  const navigation = useNavigate();
  const [visible, setVisible] = useState(false)
  const [showInput, setShowInput] = useState(false);
  const [inputPosition, setInputPosition] = useState({ x: 0, y: 0 });
  const [applicationId, setApplicationId] = useState();
  const [applicationDetails, setApplicationDetails] = useState();
  const [isBtnShowHide, setIsBtnShowHide] = useState(true);
  const [showInputfooter, setShowInputfooter] = useState(false);
  const { value } = useSelector((state) => state?.visitedUser);
  const handleClick = (event) => {
    const { offsetX, offsetY } = event.nativeEvent;
    setInputPosition({ x: offsetX, y: offsetY });
    setShowInputfooter(!showInputfooter);
    setShowInput(false)
  };

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true)
    }
    else if (scrolled <= 300) {
      setVisible(false)
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const hnadleChange = (e) => {
    setApplicationId(e.target.value)
  }

  window.addEventListener('scroll', toggleVisible);
  const initiativessettings = {
    dots: false,
    infinite: true,
    speed: 2000,
    arrow: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleOpen = (data) => {
    if (data == "facebook") window.open("https://www.facebook.com/pmbjppmbi/");
    if (data == "youtube")
      window.open("https://www.youtube.com/channel/UCyC_ZjR9g6or1e3TIFr0sPA/");
    if (data == "twitter") window.open("https://twitter.com/pmbjppmbi");
  };

  const getApplicationDetails = async (applicationId) => {
    try {
      const response = await getApplicationByApplicationId(applicationId);
      if (response?.data?.responseCode == 200) {
        setApplicationDetails(response?.data?.data)
      } else if (response?.data?.responseCode == 500) {
        toastEmitter("error", API_RESPONSE.MESSAGE_500);
      } else {
        toastEmitter("error", response?.data?.message || API_RESPONSE.MESSAGE_500);
        setApplicationDetails(response?.data?.responseCode)
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  }

  const handleApplicationStatus = () => {
    getApplicationDetails(applicationId)
  }

  const InitiativesArr = [
    { id: 1, url: "https://www.makeinindia.com/home", name: JANA_LOGO_P_1 },
    { id: 2, url: "https://wcd.nic.in/bbbp-schemes", name: JANA_LOGO_P_2 },
    { id: 3, url: "https://incredibleindia.org/", name: JANA_LOGO_P_3 },
    { id: 4, url: "https://india.gov.in/", name: JANA_LOGO_P_4 },
    { id: 5, url: "https://mygov.in", name: JANA_LOGO_P_5 },
    { id: 5, url: "https://innovateindia.mygov.in/pm-yoga-awards-2025/", name: JANA_LOGO_P_7 },
  ]

  const { t } = useTranslation();
  return (
    <>
      <div className="jana_initiatives_section ">
        <div className="jana_initiatives_innersection pb-5">
          <div className="container">
            <div className="jana_initiatives_heading_sec d-flex align-items-center justify-content-between py-3">
              <div className="jana_initiatives_heading">
                <h3 className="mb-0 ps-3">{t("Initiatives")}</h3>
              </div>
            </div>
          </div>
          <Slider {...initiativessettings}>
            {InitiativesArr?.map((item, index) => (
              <div className="slides">
                <a href={item?.url} target="_blank">
                  <img className="img-fluid" src={item?.name} alt="" />
                </a>
              </div>

            ))}

          </Slider>
        </div>
      </div>
      <footer class="px-5 py-5 footer-bg ">

        <div className="d-flex flex-wrap">
          <div className="jana_scanner mb-3">
            <div className="qr-Code">
              <QRCode
                size={155}
                fgColor="#205da6 "
                bgColor="white"
                value="https://play.google.com/store/apps/details?id=in.gov.pmbjp&hl=en_IN"
              />
            </div>

          </div>
          <div className="jana_appstore ms-0 ms-md-3 ms-lg-3 mb-3">
            <div className="text-white">

              <h4 className="text-white">
                {t("nearkendra")}              </h4>
              <h6 className="mt-2 text-white">
                {t("downloadtext")}

              </h6>
              <p className="">{t('scanapp')}</p>
              <div className="">
                <img src={GOOGLE_IMG} alt="" className="img-fluid cursor-pointer" onClick={() => window.open("https://play.google.com/store/apps/details?id=in.gov.pmbjp&hl=en_IN")} />
                <img
                  src={APP_IMG}
                  alt=""
                  className="img-fluid ms-sm-0 ms-md-0 ms-lg-3 cursor-pointer"
                  onClick={() => window.open("https://apps.apple.com/in/app/jan-aushadhi-sugam-pmbi/id1476574620")}
                />
              </div>
            </div>
          </div>
        </div>

        <hr className=" my-2"></hr>
        <div className="row ">
          <div class=" col-sm-12 col-md-6  col-lg-3  ">
            <div className="footer-sepraterborder h-100 me-5">
              <h5 className="mb-3" id="spanColor">{t("OtherLinks")}</h5>
              <ul class="nav flex-column ">
                <li class="nav-item mb-3">
                  <a class="nav-link p-0  cursor-pointer">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <Link to={ROUTES.PACSTRAINING}>
                      <span className="ms-3" id="spanColor">{t("SupportFooter")}</span>
                    </Link>
                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 cursor-pointer ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3">
                      <span id="spanColor" onClick={() => navigation(ROUTES.RTIACT)}>

                        {t("RTI")}
                      </span>{" "}
                    </span>
                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 cursor-pointer">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor" onClick={() => navigation(ROUTES.CONTACTUS)}>
                      {t("ContactUsfooter")}

                    </span>
                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 cursor-pointer">
                    {" "}
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor" onClick={() => navigation(ROUTES.PMBJBSCHEME)}>

                      {t("ABOUTUS")}

                    </span>
                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 cursor-pointer">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor" onClick={() => navigation(ROUTES.TESTIMONIALS)}>{t("TESTIMONIALS")} </span>
                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 cursor-pointer">
                    <Link
                      className=""
                      to={ROUTES.FAQ}>
                      <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                      <span className="ms-3" id="spanColor">
                        {t("FAQs")}</span>
                    </Link>
                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 cursor-pointer">
                    <Link to={ROUTES.SITEMAP} class="nav-link p-0 ">
                      <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                      <span className="ms-3" id="spanColor">{t("SITEMAP")}</span>
                    </Link>
                  </a>
                </li>
                {/* <li class="nav-item mb-3">
                  <Link to={ROUTES.RECRUITMENT} class="nav-link p-0 ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">{t("RECRUITMENTSFooter")}</span>
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>

          <div class=" col-sm-12 col-md-6  col-lg-3 ">
            <div className="footer-sepraterborder h-100 me-5">
              <h5 className="mb-3" id="spanColor">{t("NeedHelp")}</h5>
              <ul class="nav flex-column">

                <li class="nav-item mb-3">
                  <Link to={ROUTES.COPYRIGHT} class="nav-link p-0 ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">{t("COPYRIGHT")}</span>
                  </Link>
                </li>
                <li class="nav-item mb-3">
                  <Link to={ROUTES.HYPERLINKPOLICY} class="nav-link p-0 ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">{t("HYPERLINKPOLICY")}</span>
                  </Link>
                </li>
                <li class="nav-item mb-3">
                  <Link to={ROUTES.PRIVACYPOLICY} class="nav-link p-0 ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">{t('PRIVACYPOLICY')}</span>
                  </Link>
                </li>
                <li class="nav-item mb-3">
                  <Link to={ROUTES.DISCLAIMER} class="nav-link p-0 ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">{t("DISCLAIMER")}</span>
                  </Link>
                </li>
                <li class="nav-item mb-3">
                  <Link to={ROUTES.TAC} class="nav-link p-0 ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">{t("TAC")}</span>
                  </Link>
                </li>
                <li class="nav-item mb-3">
                  <Link to={ROUTES.ARCHIVE} class="nav-link p-0 ">
                    <img src={LEFTARROW_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">{t('ARCHIVE')}</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-sm-12 col-md-6  col-lg-4">
            <div className="footer-sepraterborder h-100 me-2">
              <h5 className="mb-3" id="spanColor">{t("Address")}</h5>
              <ul class="nav flex-column">
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 ">
                    <img src={CALLICON_IMG} alt="" className="img-fluid" />
                    <a href="tel:01149431800">
                      <span className="ms-3" id="spanColor">011-49431800</span>
                    </a>

                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 ">
                    <img src={NUMBERICON_IMG} alt="" className="img-fluid" />
                    <a href="fax:01149431899">
                      <span className="ms-3" id="spanColor">011-49431899</span>
                    </a>
                  </a>
                </li>
                <li class="nav-item mb-3">
                  <a class="nav-link p-0 ">
                    <img src={EMAILICON_IMG} alt="" className="img-fluid" />
                    <a href="mailto:complaints@janaushadhi.gov.in">
                      <span className="ms-3" id="spanColor">complaints[at]janaushadhi[dot]gov[dot]in</span>
                    </a>

                  </a>
                </li>
                <li class="nav-item mb-3 jana_address">
                  <a class="nav-link p-0 ">
                    <img src={ADDRESSICON_IMG} alt="" className="img-fluid" />
                    <span className="ms-3" id="spanColor">
                      {t("newaddress")}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class=" col-sm-12 col-md-6  col-lg-2 ">
            <h5 className="mb-3" id="spanColor">{t('TollFreeNo')}</h5>
            <ul class="nav flex-column">
              <li class="nav-item mb-3">
                <a class="nav-link p-0 ">
                  <img src={CALLICON_IMG} alt="" className="img-fluid" />
                  <a href="tel:18001808080"><span className="ms-3 " id="spanColor">1800-180-8080 </span></a>

                </a>
              </li>
              <li class="nav-item mb-3">
                <a class="nav-link p-0 ">
                  <img src={LOGOICON_IMG} alt="" className="img-fluid" />
                  <a href="https://janaushadhi.gov.in/" target="_blank" ><span className="ms-3 " id="spanColor">janaushadhi.gov.in </span></a>
                  {/* <span className="ms-3 " id="spanColor">janaushadhi.gov.in </span> */}
                </a>
              </li>
              <h5 className=" mb-3" id="spanColor">{t("OfficeTiming")}</h5>
              <li class="nav-item mb-3">
                <a class="nav-link p-0 ">
                  <div className="d-flex justify-content-start">
                    <div><img src={LEFTARROW_IMG} alt="" className="img-fluid me-3" /></div>
                    <div><span id="spanColor">{t("timing")}</span><br></br>
                      <span id="spanColor">{t("weekday")}</span></div>
                  </div>
                </a>
              </li>
            </ul>
            <div className="d-flex ">
              <Link onClick={() => handleOpen("facebook")}>
                <img
                  src={FACEBOOKICON_IMG}
                  alt=""
                  srcset=""
                  className="img-fluid  socialimg"
                />
              </Link>


              <Link onClick={() => handleOpen("youtube")}>
                <img
                  src={YOUTUBEICON_IMG}
                  alt=""
                  srcset=""
                  className="img-fluid socialimg ms-2"
                />
              </Link>
              <Link onClick={() => handleOpen("twitter")}>
                <img
                  src={TWITTER1_IMG}
                  alt=""
                  srcset=""
                  className="img-fluid  socialimg ms-2"
                />
              </Link>
            </div>
          </div>
        </div>
      </footer>

      <div className={`div_animation ${isBtnShowHide ? 'show' : 'hide'}`}>
        <div className="app_no-icon">
          <div className="app_status_icon-div" onClick={handleClick}>
            <img className="app_status_icon img-fluid" width="55px" src={APP_NO_IMG} />
            <div className="status-tooltip "><p className="status-tooltip-pera mb-0 ">Know Your Application Status</p></div>
          </div>

          <div className={`app-no-box ${showInputfooter ? "show" : ""}`}>
            <div className="text-center header">
              <p className="">Know Your Application Status</p>
            </div>

            <div className="app_status_box_sec">
              <p className="p-2 rounded-pill app-status-div">
                {
                  applicationDetails ? <>

                    {
                      applicationDetails?.applicationStatus == 1 && applicationDetails?.applicationFinalApproval == 1 && <p className="p-2 px-3 rounded-pill bg-light app-status-div text-success">Application Approved</p>
                    }
                    {
                      applicationDetails?.applicationStatus == 0 && <p className="p-2 px-3 rounded-pill bg-light app-status-div text-primary">Application Pending</p>
                    }
                    {
                      applicationDetails?.applicationStatus == 2 && <p className="p-2 px-3 rounded-pill bg-light app-status-div text-danger">Application Rejected</p>
                    }
                    {
                      applicationDetails?.applicationStatus == 3 && <p className="p-2 px-3 rounded-pill bg-light app-status-div text-warning">Application Hold</p>
                    }
                    {
                      applicationDetails == 404 && <p className="p-2 px-3 rounded-pill bg-light app-status-div text-danger">Application Not Exist</p>
                    }
                  </> : "No Data Found"
                }
              </p>
            </div>

            <div class="input-group">
              <input type="text" class="form-control" placeholder="Enter Your Application Id" onChange={hnadleChange}
                value={applicationId}
              />
              <span class="input-group-text" id="basic-addon1" onClick={handleApplicationStatus}><img src={SENDBTN_ICON} alt="Send Icon" width="20" /></span>
            </div>

          </div>
        </div>
        <div className="icon_chatbot_box">
          <ChatBot showInput={showInput}
            setShowInput={setShowInput}
            setShowInputfooter={setShowInputfooter}
            showInputfooter={showInputfooter}
          />
        </div>

      </div>
      <button className={`${isBtnShowHide ? "chat_cross_btn" : "chat_and_stauts_btn"}`}>
        <img className="" src={isBtnShowHide ? PMBIFOOTERCROSSBTN : PMBIFOOTERBTN} alt="" onClick={() => setIsBtnShowHide(!isBtnShowHide)} />
      </button>
      <div className="cursor-pointer text-lg-end mt-3 position-fixed bottom-0 end-0 backtopbtn" onClick={scrollToTop}
        style={{ display: visible ? 'inline' : 'none' }}>
        <img src={BACKTOTOP_IMG} alt="" className="img-fluid backtopimg me-3" />
        <p id="headingColor" className="mt-2 fw-bold mb-0">BACK TO TOP</p>
      </div>
      <div className="px-5 footerbottom-bg py-2">
        <div className="d-flex  flex-wrap justify-content-between  justify-content-center align-items-center">
          <div className=" me-md-4 mb-2 mb-md-0">
            <p className="mb-0" id="spanColor">
              {t("footercopyright_1")}{" "}{new Date().getFullYear()}{" "}{t("footercopyright_2")}
            </p>
          </div>
          <div className=" me-md-4 mb-2 mb-md-0 sepraterborder ms-lg-3">
            <p className="mb-0 me-5" id="spanColor">{t("totalvisitor")} : {value}</p>
          </div>
          <div className=" me-md-4 mb-2 mb-md-0 ">
            <p className="mb-0" id="spanColor">{t("versionUpdate")} : {process.env.REACT_APP_VERSION}</p>
          </div>
        </div>
      </div>

    </>
  );
};

export default Footer;